import styled from "styled-components";
import { Button } from "../../atoms/Button";
import { CardTemplate } from "../../templates/CardTemplate";
import { usePasskeySettingCompelete } from "./hook";

export const PasskeySettingCompletePage: React.FC = () => {
  const { handlePasskeySettingComplete } = usePasskeySettingCompelete();

  return (
    <CardTemplate title="パスキー設定完了">
      <StyledTextContainer>
        パスキーの設定が完了しました。次回ログイン時には簡単にログインが行える様になりました。下部ボタンよりトップへお進みください。
      </StyledTextContainer>

      <Button
        text="トップへ"
        variant="filled"
        onClick={handlePasskeySettingComplete}
        fullWidth
      />
    </CardTemplate>
  );
};

const StyledTextContainer = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
`;
